import React from 'react';
import { useOnboarding } from './OnboardingContext';

export function OnboardingStepper({ steps }) {
  const { currentStep } = useOnboarding();

  return (
    <div className="flex items-center justify-center gap-3 py-6">
      {steps.map((step, index) => {
        const isActive = index === currentStep;
        const isCompleted = index < currentStep;

        return (
          <div key={step.id} className="flex items-center gap-2">
            <div
              className={[
                'w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold transition-colors',
                isActive ? 'bg-cyan-500 text-white shadow-lg shadow-cyan-500/30' : isCompleted ? 'bg-cyan-900/50 text-cyan-400 border border-cyan-700/50' : 'bg-slate-700/50 text-slate-400 border border-slate-600/50',
              ].join(' ')}
            >
              {index + 1}
            </div>
            <span className={`text-sm font-medium hidden sm:block ${isActive ? 'text-cyan-400' : isCompleted ? 'text-cyan-500' : 'text-slate-500'}`}>{step.label}</span>
            {index !== steps.length - 1 && <div className="hidden sm:block w-12 h-px bg-slate-600/50" />}
          </div>
        );
      })}
    </div>
  );
}
